export default __webpack_public_path__ + "static/media/close.0fb77ae6.svg";